import clsx from 'clsx'
import { ChevronDownIcon } from 'lucide-react'
import { useState } from 'react'

import { useEmployerRenewalConfig } from 'apps/employer_renewals/providers/EmployerRenewalConfigProvider'
import { type ComplianceCalculations } from 'components/hooks/quotes/useComplianceCalculations'
import ComplianceChecks from 'components/quoting/quotes/compliance/ComplianceChecks'
import AnimateHeightAndOpacity from 'components/reusable/AnimateHeightAndOpacity'
import { SolidCircleCheckIcon, SolidCircleXIcon } from 'slab'

type Props = {
  complianceCalculations: ComplianceCalculations
  isLoading: boolean
}

export default function RenewalComplianceChecks ({ complianceCalculations, isLoading }: Props) {
  const { employerRenewalConfig, isLoading: isLoadingRenewalConfig } = useEmployerRenewalConfig()
  const [isOpen, setIsOpen] = useState(false)

  const maxEmployeeContributionPercentage = employerRenewalConfig?.renewal_year_quote.max_employee_contribution_percentage

  return (
    <div className='flex flex-col'>
      <div>
        <button className='flex items-center gap-2 cursor-pointer' onClick={() => setIsOpen(!isOpen)}>
          <ChevronDownIcon className={clsx('w-4 h-4 transition-transform duration-200', { 'rotate-180': isOpen })} />
          <div className='flex items-center gap-1'>
            <span className='body-bold'>{complianceCalculations.numPassingChecks}/{complianceCalculations.totalChecks}</span>
            <span>Compliance checks passed</span>
            {complianceCalculations.allChecksPassed
              ? <SolidCircleCheckIcon className='w-4 h-4 text-green-400' />
              : <SolidCircleXIcon className='w-4 h-4 text-red-400' />}
          </div>
        </button>
      </div>
      <AnimateHeightAndOpacity isOpen={isOpen}>
        <div className='pt-4'>
          <ComplianceChecks
            maxEmployeeContributionPercentage={maxEmployeeContributionPercentage}
            employeesWithUnaffordablePlans={complianceCalculations.employeesWithUnaffordablePlans}
            ratingAreasWithUnfairAllowances={complianceCalculations.ratingAreasWithUnfairAllowances}
            isLoading={isLoading || isLoadingRenewalConfig}
          />
        </div>
      </AnimateHeightAndOpacity>
    </div>
  )
}
